import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
import { IconSize } from '@foundation/Icon/IconSize';

import IconMoveEmphasis12 from './IconMoveEmphasis12';
import IconMoveEmphasis16 from './IconMoveEmphasis16';
import IconMoveEmphasis20 from './IconMoveEmphasis20';
import IconMoveEmphasis24 from './IconMoveEmphasis24';
import IconMoveEmphasis32 from './IconMoveEmphasis32';

/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
const IconMoveEmphasis = (props: GeneratedIconProps): ReactElement<GeneratedIconProps> => {
    const size = props.size || IconSize.Size16;
    return (
        <span>
            {size === IconSize.Size12 && !props.filled && <IconMoveEmphasis12 {...props} />}
            {size === IconSize.Size16 && !props.filled && <IconMoveEmphasis16 {...props} />}
            {size === IconSize.Size20 && !props.filled && <IconMoveEmphasis20 {...props} />}
            {size === IconSize.Size24 && !props.filled && <IconMoveEmphasis24 {...props} />}
            {size === IconSize.Size32 && !props.filled && <IconMoveEmphasis32 {...props} />}
        </span>
    );
};
IconMoveEmphasis.displayName = 'FondueIconMoveEmphasis';

export default memo(IconMoveEmphasis);
